import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

const SLink = styled(Link)`
  font-weight: ${({ selected }) => selected && 'bold'};
  width: 100%;
  height: 100%;
  display: block;
  color: #283f5f;
  font-size: 13px;
  line-height: 26px;
  &:hover,
  &:focus,
  &:active {
  }
`;
export default SLink;
